import React, {useCallback, useState} from "react";
import {
    AdditionalSectionContent,
    AdditionalSectionContainer,
    AdditionalSectionTitle,
} from "./styles";
import { ButtonsContainer, SectionSecondaryButton, SectionPrimaryButton } from "../../styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SubmitFormModal } from "../submitFormModal";
import { ROUTE_URLS } from "../../../../constants/consts";

export const AdditionalSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isSubmitModalOpen, setOpenSubmitModal] = useState(false);

    const handleNavigateToSignUp = () => {
        navigate(ROUTE_URLS.SIGN_UP);
    };

    const toggleModal = useCallback(() => {
        setOpenSubmitModal(prev => !prev);
    }, []);

    return (
        <AdditionalSectionContent
            initial={{opacity: 0, y: 50}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
        >
            <AdditionalSectionContainer>
                <AdditionalSectionTitle>{t("additional_section_title")}</AdditionalSectionTitle>
                <ButtonsContainer $shouldApplyColumnStyles>
                    <SectionPrimaryButton type="button" onClick={handleNavigateToSignUp}>{t("section_primary_button")}</SectionPrimaryButton>
                    <SectionSecondaryButton type="button" onClick={toggleModal} $withBorder>{t("section_secondary_button")}</SectionSecondaryButton>
                    <SubmitFormModal isSubmitModalOpen={isSubmitModalOpen} toggleModal={toggleModal} />
                </ButtonsContainer>
            </AdditionalSectionContainer>
        </AdditionalSectionContent>
    );
}
